import React, { useState } from 'react';
import { DeleteDialogUI, FileTabUI, TabsUI } from '../Interface';
import { OperationFormFields } from './OperationFormFields';
import { v4 as uuidv4 } from 'uuid';

export const ProductionTabs = ({
  activeTab,
  onTabChange,
  values,
  setFieldValue,
  errors,
  validateField,
  productionList,
  user,
  params,
}) => {
  const [deleteDialog, setDeletDialog] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);

  const handleUpload = (files) => {
    const filesWithId = files.map((file) => {
      file.id = uuidv4();
      return file;
    });

    const existingAttachments = Array.isArray(values.productionAttachment) ? values.productionAttachment : [];

    setFieldValue('productionAttachment', [...existingAttachments, ...filesWithId]);
  };

  const hideDeleteDialog = () => {
    setDeletDialog(false);
  };

  const handleRemoveElement = () => {
    setFieldValue(
      'productionAttachment',
      (values.productionAttachment || []).filter((productionAttachment) => productionAttachment.id !== fileToDelete.id)
    );

    setFileToDelete(null);
    hideDeleteDialog();
  };

  const tabs = [
    {
      id: 0,
      name: 'Művelet lejelentés',
      content: (
        <OperationFormFields
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          validateField={validateField}
          productionList={productionList}
          user={user}
          params={params}
        />
      ),
    },
    {
      id: 1,
      name: 'Csatolmányok',
      content: (
        <FileTabUI
          savedFiles={values?.productionAttachment ?? []}
          handleDelete={(file) => {
            setFileToDelete(file);
            setDeletDialog(true);
          }}
          handleUpload={handleUpload}
        />
      ),
    },
  ];

  const handleTabClick = (tabIndex) => {
    onTabChange(tabIndex);
  };

  return (
    <div className="mt-3">
      <div className="px-3">
        <TabsUI activeTab={activeTab} handleTabClick={handleTabClick}>
          {tabs.map((tab, index) => (
            <div key={index} name={tab.name}>
              {tab.content}
            </div>
          ))}
        </TabsUI>
      </div>
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={deleteDialog}
        onHide={() => {
          hideDeleteDialog();
          setFileToDelete(null);
        }}
      />
    </div>
  );
};
